export const ACCOUNT_STOP_OUT_LEVEL_VALUES = {
    DEFAULT: 50,
    ZERO: 0,
} as const;
